import { render, staticRenderFns } from "./TheImageUploader.vue?vue&type=template&id=0dc46538"
import script from "./TheImageUploader.vue?vue&type=script&lang=js"
export * from "./TheImageUploader.vue?vue&type=script&lang=js"
import style0 from "./TheImageUploader.vue?vue&type=style&index=0&id=0dc46538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports